import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { settlementApi } from "../../../api/settlementApi";
import { SETTLEMENT_BATCH_PENDING_REFRESH_EVENT } from "../../../utils/settlementBatchPending";

export function useSettlementBadge({ auth, pathname }) {
    const [batchPendingDetail, setBatchPendingDetail] = useState({
        total_pending: 0,
        needs_recalculation: 0,
        failed: 0,
        running: 0,
    });
    const pendingCountTimerRef = useRef(null);
    const { hasPermission } = auth;
    const canAccessSettlement = hasPermission("settlement:read");

    const fetchBatchPendingCount = useCallback(async () => {
        try {
            const response = await settlementApi.batchCalculations.getPendingCount();

            if (response?.data) {
                setBatchPendingDetail({
                    total_pending: response.data.total_pending || 0,
                    needs_recalculation: response.data.needs_recalculation || 0,
                    failed: response.data.failed || 0,
                    running: response.data.running || 0,
                });
            }
        } catch {
            // 静默失败，不影响主流程
        }
    }, []);

    useEffect(() => {
        if (!canAccessSettlement) {
            return undefined;
        }

        fetchBatchPendingCount();
        window.addEventListener(SETTLEMENT_BATCH_PENDING_REFRESH_EVENT, fetchBatchPendingCount);
        pendingCountTimerRef.current = setInterval(() => {
            fetchBatchPendingCount();
        }, 300000);

        return () => {
            window.removeEventListener(SETTLEMENT_BATCH_PENDING_REFRESH_EVENT, fetchBatchPendingCount);
            if (pendingCountTimerRef.current) {
                clearInterval(pendingCountTimerRef.current);
            }
        };
    }, [canAccessSettlement, fetchBatchPendingCount]);

    useEffect(() => {
        if (!canAccessSettlement) {
            return;
        }

        if (pathname.includes("/settlement/batch-calculations")) {
            fetchBatchPendingCount();
        }
    }, [canAccessSettlement, pathname, fetchBatchPendingCount]);

    const badgeCounts = useMemo(
        () => ({
            batchPendingCount: batchPendingDetail.total_pending,
            batchPendingDetail,
        }),
        [batchPendingDetail],
    );

    return { badgeCounts };
}
